import { createContext, Dispatch, FC, ReactNode, SetStateAction, useContext, useState } from 'react';

type LandsCapeViewContextType = {
  isLandscapeActive: boolean;
  setIsLandscapeActive: Dispatch<SetStateAction<boolean>>;
};

const DEFAULT_STATE = {
  isLandscapeActive: true,
};

export const LandscapeViewContext = createContext<LandsCapeViewContextType | null>(null);

export const LandscapeViewContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isLandscapeActive, setIsLandscapeActive] = useState<boolean>(DEFAULT_STATE.isLandscapeActive);

  return (
    <LandscapeViewContext.Provider value={{ isLandscapeActive, setIsLandscapeActive }}>
      {children}
    </LandscapeViewContext.Provider>
  );
};

export const useLandscapeViewContext = (): LandsCapeViewContextType => {
  const context = useContext(LandscapeViewContext);

  if (!context) {
    throw new Error(
      `The component that calls useLandscapeViewContext() needs to be a deep child of <LandscapeViewContextProvider>`,
    );
  }

  return context;
};
